<template>
    <div v-if="locationsEnabled" class="filter-container" @click="handleClose">
        <button-filter-dropdown @click="open" :isExpanded="modalOpen">
            <template v-slot:buttonFilterContent>
                <span v-if="!selectedLocations.length">
                    {{locationHeader}}
                </span>
                <span v-else :class="{'has-multiple' : selectedLocations.length > 1}">
                    <template v-for="(selected, index) in selectedLocations">
                        {{index < selectedLocations.length - 1 ? selected + ',' : selected}}
                    </template>
                </span>
            </template>
        </button-filter-dropdown>

        <modal-filter-dropdown :items="locations" v-show="modalOpen">
            <template #modalFilterType="item">
                <div>
                    <label>
                        <input :checked="isChecked(item.props.Key)" @change="check($event)" type="checkbox" :value="item.props.Key" name="filterAreaCheckbox" />
                        <span>
                            {{item.props.Value}}
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15" width="18" height="15" aria-hidden="true" focusable="false">
                            <path fill="#000" d="M16 0l1.43 1.4L4.98 14.13 0 9.037l1.43-1.398 3.55 3.63z"></path>
                            </svg>
                        </span>
                    </label>
                </div>
            </template>
        </modal-filter-dropdown>
    </div>
</template>

<script>
import Vue from 'vue';
import Vuex from 'vuex';
import merlinFilterDropdown from '../../shared/merlinFilterDropdown.vue';
import { mapState, mapGetters } from 'vuex';
import EventBus from '../event-bus';
import buttonFilterDropdown from '../../shared/buttonFilterDropdown.vue'
import modalFilterDropdown from '../../shared/modalFilterDropdown.vue'

export default {
    components: {
        buttonFilterDropdown,
        modalFilterDropdown
    },
    extends: merlinFilterDropdown,
    methods: {
        check(e) {

            if (!e.target.checked) {
                this.$store.commit('locations/toggleCheckedLocation', e.target.value);
                this.$store.dispatch('locations/toggleActiveLocations', e.target.value);
                this.$store.dispatch('areas/resetAreas');
                this.$store.dispatch('filterAttractions', e.target.value);
            } else {
                this.$store.commit('locations/toggleCheckedLocation', e.target.value);
                this.$store.dispatch('locations/toggleActiveLocations', e.target.value);
                this.$store.dispatch('areas/resetAreas');
                this.$store.dispatch('filterAttractions');
            }
        },
        isChecked(key){
            return this.activeLocations.includes(key);
        },
    },
    computed: {
        ...mapState('locations',
            ['locations', 'locationHeader', 'locationsEnabled', 'activeLocations']),
        ...mapGetters(['getBody']),
        selectedLocations() {
            return this.locations && this.locations.filter((location) => {
                if (this.activeLocations.includes(location.Key)) {
                    return location.Value;
                }
                }).map((filtered) => {
                    return filtered.Value;
                });
        }
    }
};

</script>